import React, { useEffect, useMemo, useRef, useState } from "react";
import { Row, Col, Button } from "reactstrap";
import CustomForm from "../../custom/Forms/CustomForm";
import SelectInput from "./../../custom/components/Select-Input/SelectInput";
import TextInput from "../../custom/components/Text-Input/TextInput";
import DatePicker from "./../../custom/components/Date-Picker/DatePicker";
import TextAreaInput from "./../../custom/components/TextArea-Input/TextAreaInput";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, orderFormData } from "./OrderFile";
import SelectInputPercentage from "../../custom/components/Select-Input-Percentag/SelectInputPercentage";
import ModernPopup from "../../services/popup/Popup";
import {
  dropdownData,
  formatDate,
  formatNumber,
  getRecords,
  imageURL,
  saveRecords,
  uploadFile,
} from "../../services/api.service";
import { toast } from "react-toastify";
import NumberInput from "./../../custom/components/Number-Input/NumberInput";
import { TransactionalValidation } from "../../custom/validations/TransactionalValidation";
import CheckboxInput from "../../custom/components/CheckBox-Input/CheckboxInput";
import Asterisks from "../../custom/components/Asterisks/Asterisks";
import CustomError from "../../custom/components/Errors/CustomError";
import * as XLSX from "xlsx";

const OrderCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    getEndpoint,
  } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(orderFormData());
  const [expandedRows, setExpandedRows] = useState({});
  const [customerSelect, setCustomerSelect] = useState("");
  const [customerSelectOptions, setCustomerSelectOptions] = useState([]);
  const [itemCodeSelect, setItemCodeSelect] = useState([]);
  const [itemSelectOptions, setItemSelectOptions] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [inputValue, setInputValue] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [stageSelectOption, setStageSelectedOptions] = useState([]);
  const [fetchedData, setFetchedData] = useState(null);
  const [selectedFilteredItems, setSelectedFilteredItems] = useState([]);
  const [filteredOptionsWithoutSelected, setFilteredOptionsWithoutSelected] =
    useState([]);
  const [importLoading, setImportLoading] = useState(false);

  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  const fileInputRef = useRef(null);
  const [popupData, setPopupData] = useState({
    isOpen: false,
    message: "",
    isError: false,
  });

  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      inputRef.current &&
      !inputRef.current.contains(event.target)
    ) {
      setIsDropdownVisible(false);
    }
  };

  // useEffect(() => {
  //   setFilteredOptions(
  //     itemSelectOptions[0]?.options.filter(
  //       (option) =>
  //         !selectedFilteredItems.some(
  //           (selected) =>
  //             (selected?.item_code && selected?.item_code == option?.label) ||
  //             (selected?.label && selected?.label == option?.label)
  //         )
  //     )
  //   );
  // }, [itemSelectOptions]);

  useEffect(() => {
    setFilteredOptions(itemSelectOptions[0]?.options || []);
  }, [itemSelectOptions]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    getUserMastersDropData();
    getItemMasterDropData();
    getPaymentStageDropData();
  }, []);

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  useEffect(() => {
    if (fetchedData) {
      setFormData((prev) => {
        const updatedDetails =
          fetchedData?.orderItemDetails &&
          fetchedData?.orderItemDetails.map((item) => ({
            ...item,
            item_id: item?.item_id,
            description: item?.item?.description,
            customer_desc: item?.customer_desc,
            uom: item?.item?.uom?.uom_name,
            type: item?.item?.type,
            unit_rate: item?.unit_rate,
            is_active: item?.is_active,
            ...(item?.item?.type === 1 && {
              buy_item_details: item?.buy_item_details
                ? item?.buy_item_details.map((bomItem) => ({
                    item_id: bomItem?.item_id,
                    item_code: bomItem?.item_code,
                    description: bomItem?.item?.description,
                    qty: bomItem?.qty_per_item,
                    uom: bomItem?.uom,
                  }))
                : [],
            }),
          }));

        return {
          ...prev,
          inputData: {
            ...prev.inputData,
            ...fetchedData,
            orderItemDetails: updatedDetails,
            pan_no: fetchedData?.company?.pan_no,
            gst_no: fetchedData?.company?.gst_no,
          },
        };
      });
    }
  }, [fetchedData]);

  const getEditData = async (id) => {
    try {
      setLoadingData(true);

      let payload = {
        modelName: "orders",
        modifyResponse: true,
        getBuyItemObject: true,
        whereCondition: {
          id: id,
        },
        relations: [
          {
            module: "order_payment_details",
            moduleAs: "orderPaymentDetails",
          },
          {
            module: "order_items",
            moduleAs: "orderItemDetails",
            subModule: "item_masters",
            subModuleAs: "item",
            subSubModule: "uom_masters",
            subSubModuleAs: "uom",
          },
          {
            module: "projects",
            moduleAs: "project",
          },
          {
            module: "company_masters",
            moduleAs: "company",
          },
          {
            module: "order_documents",
            moduleAs: "order_documents",
          },
        ],
      };

      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        getUserMastersDropData(data?.customer_id);
        getItemMasterDropData(data?.orderItemDetails);
        setFetchedData(data);
        setLoadingData(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const getUserMastersDropData = async (customerId) => {
    try {
      let payload = {
        modelName: "company_masters",
        whereCondition: {
          type: 2,
          is_active: true,
        },
      };
      const responseData = await getRecords(payload, "/listCustomers");
      if (responseData.data && responseData.data.length > 0) {
        const dropdownResponseData = await dropdownData(
          responseData.data,
          "company_name"
        );
        if (id) {
          dropdownResponseData[0].options?.forEach((element) => {
            if (element?.value == customerId) {
              setCustomerSelect(element);
            }
          });
        }
        setCustomerSelectOptions(dropdownResponseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getPaymentStageDropData = async () => {
    try {
      let payload = {
        modelName: "payment_stage_masters",
        whereCondition: {
          is_active: true,
        },
      };

      const responseData = await getRecords(payload, "/getRecords");
      if (responseData?.data && responseData.data.length > 0) {
        const dropdownResponseData = await dropdownData(
          responseData.data,
          "stage"
        );
        setStageSelectedOptions(dropdownResponseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getItemMasterDropData = async (itemID) => {
    try {
      let payload = {
        modelName: "item_masters",
        whereCondition: {
          is_active: true,
        },
        relations: [
          {
            module: "uom_masters",
            moduleAs: "uom",
          },
          {
            module: "category_masters",
            moduleAs: "category",
          },
          {
            module: "user_masters",
            moduleAs: "createdBy",
          },
          {
            module: "user_masters",
            moduleAs: "updatedBy",
          },
        ],
      };
      const responseData = await getRecords(payload, "/listItem");

      if (responseData.data && responseData.data.length > 0) {
        const dropdownResponseData = await dropdownData(
          responseData.data,
          "item_code"
        );

        if (id) {
          const matchingItems =
            itemID?.map((item) =>
              !item.is_active
                ? undefined
                : dropdownResponseData[0]?.options?.find(
                    (element) => item.item_id === element?.value
                  )
            ) || [];

          setItemCodeSelect((prev) => [...prev, ...matchingItems]);
          setSelectedFilteredItems((prev) => [...prev, ...matchingItems]);
        }

        setItemSelectOptions(dropdownResponseData);

        setFilteredOptions((prevOptions) =>
          dropdownResponseData[0]?.options.filter(
            (option) =>
              !selectedFilteredItems.some(
                (selected) => selected?.label === option?.label
              )
          )
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getItemMasterByIdData = async (Id, index) => {
    try {
      let payload = {
        modelName: "item_masters",
        whereCondition: {
          id: Id,
        },
        relations: [
          {
            module: "bom_masters",
            moduleAs: "bomMakeItem",
            subModule: "item_masters",
            subModuleAs: "buyItem",
            subSubModule: "uom_masters",
            subSubModuleAs: "uom",
          },
          {
            module: "uom_masters",
            moduleAs: "uom",
          },
          {
            module: "category_masters",
            moduleAs: "category",
          },
          {
            module: "user_masters",
            moduleAs: "createdBy",
          },
          {
            module: "user_masters",
            moduleAs: "updatedBy",
          },
        ],
      };
      const responseData = await getRecords(payload, "/getItemById");
      if (responseData.data && responseData.data.length > 0) {
        responseData.data.forEach((item, _) => {
          setFormData((prev) => {
            const updatedDetails = [...prev.inputData.orderItemDetails];
            updatedDetails[index] = {
              ...updatedDetails[index],
              item_id: item?.id,
              description: item?.description,
              customer_desc: "",
              uom: item?.uom?.uom_name,
              type: item?.type,
              unit_rate: null,
              is_active: item?.is_active,
              ...(item?.type === 1 && {
                buy_item_details: item?.bomMakeItem
                  ? item?.bomMakeItem.map((bomItem) => ({
                      item_id: bomItem?.buyItem?.id,
                      item_code: bomItem?.buyItem?.item_code,
                      description: bomItem?.buyItem?.description,
                      qty: bomItem?.qty_per_item,
                      uom: bomItem?.buyItem?.uom.uom_name,
                    }))
                  : [],
              }),
            };
            return {
              ...prev,
              inputData: {
                ...prev.inputData,
                orderItemDetails: updatedDetails,
              },
            };
          });
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    const fieldError = TransactionalValidation(validationType, {
      [name]: value,
    });

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: fieldError[name] || null,
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]: type === "checkbox" ? (checked === true ? true : false) : value,
      },
    }));
  };

  const handleCustomerSelect = (options) => {
    const selectedValue = options?.value || null;
    const isSelected = selectedValue;

    // Validate customer_id and update errors
    const fieldError = TransactionalValidation(validationType, {
      customer_id: selectedValue,
    });

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      customer_id: fieldError?.customer_id || "",
      pan_no: "",
      gst_no: "",
    }));

    // Update selected customer
    setCustomerSelect(isSelected ? options : "");

    // Find matching data if a customer is selected
    const matchingData = isSelected
      ? options?.data?.find((item) => item.id === selectedValue)
      : null;

    // Update form data accordingly
    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        customer_id: selectedValue,
        pan_no: matchingData?.pan_no || "",
        gst_no: matchingData?.gst_no || "",
      },
    }));
  };

  const handleAddPaymentDetails = () => {
    const errors = { orderPaymentDetails: {} }; // Initialize errors object

    const totalPercentage = formData?.inputData?.orderPaymentDetails.reduce(
      (sum, item) => {
        if (item.is_active) {
          return sum + (item.percentage || 0);
        }
        return sum;
      },
      0
    );
    if (totalPercentage === 100) {
      toast.error(
        "The total payment percentage is already 100%, you can't add a new row."
      );
      return;
    }

    formData?.inputData?.orderPaymentDetails?.forEach((row, index) => {
      if (row.is_active) {
        ["stage_id", "percentage", "date"].forEach((field) => {
          if (!row[field]?.toString().trim()) {
            if (!errors.orderPaymentDetails[index]) {
              errors.orderPaymentDetails[index] = {};
            }
            errors.orderPaymentDetails[index][field] = `${field
              .replace(/_/g, " ")
              .replace(/\b\w/g, (char) => char.toUpperCase())} is required`;
          }
        });
      }
    });

    // If validation passed, add a new row and update the form errors state
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      orderPaymentDetails: {
        ...prevErrors.orderPaymentDetails,
        ...errors.orderPaymentDetails,
      },
    }));
    const lastPaymentDetails =
      formData?.inputData?.orderPaymentDetails[
        formData?.inputData?.orderPaymentDetails?.length - 1
      ];

    if (lastPaymentDetails?.is_active) {
      const isPreviousRowValid =
        lastPaymentDetails?.stage_id !== null &&
        lastPaymentDetails?.percentage !== null &&
        lastPaymentDetails?.date !== null;

      if (!isPreviousRowValid) {
        toast.error(
          "Please fill all fields in the existing rows before adding a new row."
        );
        return;
      }
    }

    // Add a new row to orderPaymentDetails
    setFormData((prev) => ({
      ...prev,
      inputData: {
        ...prev.inputData,
        orderPaymentDetails: [
          ...prev.inputData?.orderPaymentDetails,
          { stage_id: null, percentage: null, date: null, is_active: true },
        ],
      },
    }));
  };

  const handleRemovePaymentDetails = (index) => {
    const updatedErrors = { ...formErrors };
    delete updatedErrors?.orderPaymentDetails?.[index];

    setFormData((prev) => {
      const updatedDetails = prev.inputData.orderPaymentDetails
        .map((item, i) => {
          if (i === index) {
            if (item.id) {
              return { ...item, is_active: false, percentage: null };
            } else {
              return null;
            }
          }
          return item;
        })
        .filter((item) => item !== null);

      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          orderPaymentDetails: updatedDetails,
        },
      };
    });

    setFormErrors(updatedErrors);
  };

  const handleStageSelect = (selected, index) => {
    setFormData((prev) => {
      const updatedDetails = [...prev.inputData.orderPaymentDetails];
      updatedDetails[index].stage_id = selected
        ? selected.value
        : prev.inputData.orderPaymentDetails[index].stage_id;

      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          orderPaymentDetails: updatedDetails,
        },
      };
    });

    setFormErrors((prevErrors) => {
      if (selected) {
        const updatedErrors = { ...prevErrors };

        if (updatedErrors.orderPaymentDetails?.[index]) {
          delete updatedErrors.orderPaymentDetails[index].stage_id;

          if (
            Object.keys(updatedErrors.orderPaymentDetails[index]).length === 0
          ) {
            delete updatedErrors.orderPaymentDetails[index];
          }
        }

        return updatedErrors;
      }

      return prevErrors; // Keep previous errors unchanged
    });
  };

  const handlePercentageChange = (e, index) => {
    const { name, value } = e.target;

    const currentValue = value?.trim() === "" ? "" : parseFloat(value);
    let errorMessage = "";

    setFormData((prev) => {
      const updatedDetails = [...(prev.inputData?.orderPaymentDetails || [])];

      const totalPercentageBefore = updatedDetails
        .filter((payment, i) => i !== index && payment.is_active)
        .reduce((sum, item) => sum + (item.percentage || 0), 0);

      const maxAllowedValue = 100 - totalPercentageBefore;

      // Step 1: Handle empty value (clearing the field)
      if (currentValue === "") {
        updatedDetails[index].percentage = "";
        errorMessage = "Percentage is required";
      } else if (
        currentValue !== "" &&
        (isNaN(currentValue) ||
          currentValue < 0 ||
          currentValue > maxAllowedValue)
      ) {
        updatedDetails[index].percentage = "";
        errorMessage = `The value cannot go beyond ${maxAllowedValue}% because the total needs to stay at exactly 100%`;

        // Show your custom popup for errors
        setPopupData({
          isOpen: true,
          message: errorMessage,
          isError: true,
        });
      } else {
        updatedDetails[index].percentage = currentValue;
        errorMessage = ""; // Clear any previous error message if valid value
      }

      // Step 2: Remove the error if the percentage is valid (on change)
      setFormErrors((prevErrors) => {
        let updatedErrors = { ...prevErrors };

        if (errorMessage) {
          updatedErrors.orderPaymentDetails = {
            ...(updatedErrors.orderPaymentDetails || {}),
            [index]: {
              ...(updatedErrors.orderPaymentDetails?.[index] || {}),
              [name]: errorMessage,
            },
          };
        } else {
          // Remove the error if the percentage is valid or empty
          updatedErrors.orderPaymentDetails = {
            ...(updatedErrors.orderPaymentDetails || {}),
            [index]: {
              ...(updatedErrors.orderPaymentDetails?.[index] || {}),
              [name]: "", // Clear the error
            },
          };
        }

        return updatedErrors;
      });

      // Step 3: Update the form data with the modified orderPaymentDetails
      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          orderPaymentDetails: updatedDetails,
        },
      };
    });
  };

  const handleDateChange = (e, index) => {
    const { name, value } = e.target;
    let errorMessage = "";

    // Step 1: Validate the input
    if (!value.trim()) {
      errorMessage = "Date is required"; // Show below the field
    }

    setFormData((prevState) => {
      const updatedOrderPaymentDetails = [
        ...prevState.inputData.orderPaymentDetails,
      ];

      updatedOrderPaymentDetails[index] = {
        ...updatedOrderPaymentDetails[index],
        [name]: value, // Update the date
      };

      return {
        ...prevState,
        inputData: {
          ...prevState.inputData,
          orderPaymentDetails: updatedOrderPaymentDetails,
        },
      };
    });

    setFormErrors((prevErrors) => {
      let updatedErrors = { ...prevErrors };

      if (errorMessage) {
        updatedErrors.orderPaymentDetails = {
          ...(updatedErrors.orderPaymentDetails || {}),
          [index]: {
            ...(updatedErrors.orderPaymentDetails?.[index] || {}),
            [name]: errorMessage,
          },
        };
      } else {
        if (updatedErrors.orderPaymentDetails?.[index]) {
          delete updatedErrors.orderPaymentDetails[index][name];
          if (
            Object.keys(updatedErrors.orderPaymentDetails[index]).length === 0
          ) {
            delete updatedErrors.orderPaymentDetails[index];
          }
        }
      }

      return updatedErrors;
    });
  };

  const handleAddItemDetail = () => {
    setTimeout(() => {
      document
        .getElementById("table-container")
        ?.scrollTo({ top: 9999, behavior: "smooth" });
      window.scrollTo({
        top: window.scrollY + 300,
        behavior: "smooth",
      });
    }, 100);
    let errors = {};

    formData?.inputData &&
      formData?.inputData?.orderItemDetails &&
      formData?.inputData?.orderItemDetails?.forEach((row, index) => {
        if (row?.is_active == true) {
          [
            "item_id",
            "qty",
            "customer_desc",
            "unit_rate",
            "gst_percentage",
          ].forEach((field) => {
            if (!row[field]?.toString().trim()) {
              errors.orderItemDetails = {
                ...errors.orderItemDetails,
                [index]: {
                  ...errors.orderItemDetails?.[index],
                  [field]: `${field
                    .replace(/_/g, " ")
                    ?.replace(/\b\w/g, (char) =>
                      char?.toUpperCase()
                    )} is required`,
                },
              };
            } else if (field === "qty") {
              const value = parseFloat(row[field]);
              if (value <= 0) {
                errors.orderItemDetails = {
                  ...errors.orderItemDetails,
                  [index]: {
                    ...errors.orderItemDetails?.[index],
                    [field]: "Invalid qty",
                  },
                };
              }
            }
          });
        }
      });

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    setFormData((prev) => ({
      ...prev,
      inputData: {
        ...prev.inputData,
        orderItemDetails: [
          ...prev.inputData?.orderItemDetails,
          {
            item_id: null,
            description: "",
            uom: "",
            type: 2,
            unit_rate: null,
            qty: null,
            gst_percentage: null,
            amount: 0,
            is_active: true,
            buy_item_details: [],
          },
        ],
      },
    }));
  };

  const handleRemoveItemDetail = (item_id, index) => {
    setFormErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (updatedErrors?.orderItemDetails) {
        delete updatedErrors.orderItemDetails[item_id];
      }
      return updatedErrors;
    });

    setSelectedFilteredItems((prevSelected) => {
      const updatedSelected = [...prevSelected];

      const itemIndex = prevSelected.findIndex(
        (item) => item?.id == item_id || item?.value == item_id
      );

      if (itemIndex !== -1) {
        updatedSelected[itemIndex] = undefined;
      }
      setFilteredOptions((prevOptions) => itemSelectOptions[0]?.options || []);

      return updatedSelected;
    });

    setFormData((prev) => {
      const updatedDetails = prev.inputData.orderItemDetails.map((item) =>
        item.item_id == item_id
          ? {
              ...item,
              is_active: false,
              unit_rate: 0,
              amount: 0,
              qty: 0,
              gst_percentage: 0,
            }
          : item
      );

      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          orderItemDetails: updatedDetails,
        },
      };
    });
    // setItemCodeSelect((prevSelected) => {
    //   const removedItem = prevSelected.find((item) => item?.value === item_id);

    //   return prevSelected.filter((item) => item?.value !== item_id);
    // });
    setItemCodeSelect((prevSelected) => {
      const updatedSelected = [...prevSelected];

      const itemIndex = prevSelected.findIndex(
        (item) => item?.value === item_id
      );

      if (itemIndex !== -1) {
        updatedSelected[itemIndex] = undefined;
      }

      return updatedSelected;
    });
  };

  const handleDropdownChange = (index, selected) => {
    if (!selected?.value) return;
    // setSelectedFilteredItems((prev) => {
    //   const updatedItems = prev.filter((item) => item != prev[index]);
    //   return [...updatedItems, selected];
    // });
    setSelectedFilteredItems((prev) => {
      const updatedArray = [...prev];
      updatedArray[index] = selected;
      return updatedArray;
    });

    setFormErrors((prev) => ({
      ...prev,
      orderItemDetails: {
        ...prev.orderItemDetails,
        [index]: {
          ...prev.orderItemDetails?.[index],
          item_id: "",
        },
      },
    }));
    setFilteredOptions(
      itemSelectOptions[0]?.options.filter(
        (option) =>
          !selectedFilteredItems.some(
            (selected) => selected?.label && selected?.label == option?.label
          )
      )
    );
    setItemCodeSelect((prev) => {
      const updatedArray = [...prev];
      updatedArray[index] = selected;
      return updatedArray;
    });

    getItemMasterByIdData(selected.value, index);
  };
  const handleQTYChange = (value, index, field, row) => {
    let error = null;
    let numericValue = value?.trim() == "" ? "" : parseFloat(value); // Convert empty string to 0

    if (field === "qty") {
      if (row && id) {
        const invoice_qty = row?.invoice_qty;
        if (numericValue < invoice_qty) {
          error = "Order Qty Should Not be Less Than Invoice Qty";
        }
      }
      if (!value?.trim()) {
        error = "Qty is required";
      } else if (isNaN(numericValue) || numericValue <= 0) {
        error = "Invalid qty";
      }
    }

    setFormData((prev) => {
      const updatedDetails = [...prev.inputData?.orderItemDetails];

      const unitRate = parseFloat(updatedDetails[index]?.unit_rate || "0");
      const gstQty = parseFloat(updatedDetails[index]?.gst_percentage || "0");

      const baseAmount =
        numericValue * unitRate || updatedDetails[index]?.amount;
      const gstAmount = (baseAmount * gstQty) / 100;
      const totalWithGST = baseAmount + gstAmount;

      updatedDetails[index] = {
        ...updatedDetails[index],
        [field]: numericValue,
        amount: totalWithGST,
      };

      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          orderItemDetails: updatedDetails,
        },
      };
    });

    setFormErrors((prevErrors) => {
      const newErrors = {
        ...prevErrors,
        orderItemDetails: {
          ...prevErrors.orderItemDetails,
          [index]: {
            ...prevErrors.orderItemDetails?.[index],
            [field]: error,
          },
        },
      };
      return newErrors;
    });
  };

  const handleUnitRateChange = (value, index, field) => {
    let error = null;

    if (field === "unit_rate") {
      if (!value) {
        error = "Unit rate is required";
      }
    }

    setFormData((prev) => {
      const updatedDetails = [...prev.inputData?.orderItemDetails];
      const qty = parseFloat(updatedDetails[index]?.qty || "0");
      const gstQty = parseFloat(updatedDetails[index]?.gst_percentage || "0");
      const baseAmount =
        qty || value ? parseFloat(value) * qty : updatedDetails[index]?.amount;
      const gstAmount = (baseAmount * gstQty) / 100;
      const totalWithGST = baseAmount + gstAmount;

      updatedDetails[index] = {
        ...updatedDetails[index],
        [field]: value,
        amount: totalWithGST,
      };

      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          orderItemDetails: updatedDetails,
        },
      };
    });

    setFormErrors((prevErrors) => {
      const newErrors = {
        ...prevErrors,
        orderItemDetails: {
          ...prevErrors.orderItemDetails,
          [index]: {
            ...prevErrors.orderItemDetails?.[index],
            [field]: error,
          },
        },
      };
      return newErrors;
    });
  };

  const handleDescriptionChange = (value, index, field) => {
    let error = null;
    if (field === "customer_desc") {
      if (!value) {
        error = "Customer description is required";
      }
    }

    setFormData((prev) => {
      const updatedDetails = [...prev.inputData?.orderItemDetails];
      updatedDetails[index] = {
        ...updatedDetails[index],
        [field]: value,
      };

      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          orderItemDetails: updatedDetails,
        },
      };
    });

    setFormErrors((prevErrors) => {
      const newErrors = {
        ...prevErrors,
        orderItemDetails: {
          ...prevErrors.orderItemDetails,
          [index]: {
            ...prevErrors.orderItemDetails?.[index],
            [field]: error,
          },
        },
      };
      return newErrors;
    });
  };

  const handleGSTChange = (value, index, field) => {
    let error = null;

    if (field === "gst_percentage") {
      if (!value) {
        error = "gst percentage is required";
      }
    }

    setFormData((prev) => {
      const updatedDetails = [...prev.inputData?.orderItemDetails];
      const qty = parseFloat(updatedDetails[index]?.qty || "0");
      const unitRate = parseFloat(updatedDetails[index]?.unit_rate || "0");
      const baseAmount =
        unitRate || qty ? qty * unitRate : updatedDetails[index]?.amount;
      const gstAmount = (baseAmount * parseFloat(value || 0)) / 100;
      const totalWithGST = baseAmount + gstAmount;

      updatedDetails[index] = {
        ...updatedDetails[index],
        [field]: parseFloat(value),
        amount: totalWithGST,
      };

      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          orderItemDetails: updatedDetails,
        },
      };
    });

    setFormErrors((prevErrors) => {
      const newErrors = {
        ...prevErrors,
        orderItemDetails: {
          ...prevErrors.orderItemDetails,
          [index]: {
            ...prevErrors.orderItemDetails?.[index],
            [field]: error,
          },
        },
      };
      return newErrors;
    });
  };

  const toggleChildBuyItemDetail = (index) => {
    setExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handleAddUserDocuments = () => {
    const additionalErrors = {};
    formData?.inputData?.order_documents?.forEach((row, index) => {
      if (row?.is_active) {
        ["document", "file"].forEach((field) => {
          if (!row[field]?.toString().trim()) {
            additionalErrors.order_documents = {
              ...additionalErrors.order_documents,
              [index]: {
                ...additionalErrors.order_documents?.[index],
                [field]: `${field.replace(/_/g, " ")} is required`,
              },
            };
          }
        });
      }
    });

    if (Object.keys(additionalErrors).length > 0) {
      setFormErrors(additionalErrors);
      return;
    }
    const updatedDocuments = [
      ...formData.inputData.order_documents,
      { document: "", file: null, preview: "", is_active: true },
    ];
    setFormData({
      ...formData,
      inputData: { ...formData.inputData, order_documents: updatedDocuments },
    });
  };

  const handleUserDocumentsOnChange = (e, index) => {
    const { name, value } = e.target;
    const updatedDocuments = [...formData.inputData.order_documents];
    updatedDocuments[index][name] = value;

    let fieldError = "";

    switch (name) {
      case "document":
        if (!value.trim()) {
          fieldError = "document is required";
        }
        break;
      default:
        break;
    }

    setFormErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      const documentErrors = { ...updatedErrors.order_documents };

      if (!documentErrors[index]) {
        documentErrors[index] = {};
      }

      if (fieldError) {
        documentErrors[index][name] = fieldError;
      } else {
        delete documentErrors[index][name];
      }

      if (Object.keys(documentErrors[index]).length === 0) {
        delete documentErrors[index];
      }

      if (Object.keys(documentErrors).length > 0) {
        updatedErrors.order_documents = documentErrors;
      } else {
        delete updatedErrors.order_documents;
      }

      return updatedErrors;
    });

    setFormData({
      ...formData,
      inputData: { ...formData.inputData, order_documents: updatedDocuments },
    });
  };

  const handleUserDocumentFileChange = async (e, index) => {
    const selectedFile = e.target.files[0];
    let errors = {};
    errors.file = selectedFile ? "" : "file is required.";

    if (selectedFile) {
      try {
        setFormErrors((prev) => ({
          ...prev,
          order_documents: {
            ...prev.order_documents,
            [index]: {
              ...prev.order_documents?.[index],
              ...errors,
            },
          },
        }));

        const readFileAsBase64 = (file) => {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(file);
          });
        };

        const base64Data = await readFileAsBase64(selectedFile);

        const response = await uploadFile("uploads", selectedFile);

        if (response?.filePath) {
          // Create a new array to avoid mutating state directly
          const updatedDocuments = formData.inputData.order_documents.map(
            (doc, i) =>
              i === index
                ? {
                    ...doc,
                    file: response?.fileName,
                    preview: base64Data,
                  }
                : doc
          );

          setFormData((prevState) => ({
            ...prevState,
            inputData: {
              ...prevState.inputData,
              order_documents: updatedDocuments,
            },
          }));
        }
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }
  };

  const handleRemoveUserDocuments = (index) => {
    const updatedErrors = { ...formErrors };
    delete updatedErrors.order_documents?.[index];

    setFormData((prev) => {
      const updatedDetails = prev.inputData.order_documents
        .map((doc, i) => {
          if (i === index) {
            if (doc.id) {
              return { ...doc, is_active: false, percentage: null };
            } else {
              return null;
            }
          }
          return doc;
        })
        .filter((doc) => doc !== null);

      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          order_documents: updatedDetails,
        },
      };
    });

    setFormErrors(updatedErrors);
  };

  const handleImageClick = (imageSrc) => {
    window.open(imageSrc, "_blank");
  };

  // Calculate totals for the columns
  const totalQty =
    formData?.inputData &&
    formData?.inputData?.orderItemDetails &&
    formData?.inputData?.orderItemDetails
      ?.filter((payment) => payment.is_active)
      .reduce((acc, item) => acc + (parseFloat(item.qty) || 0), 0);

  const totalUnitRate =
    formData?.inputData &&
    formData?.inputData?.orderItemDetails &&
    formData?.inputData?.orderItemDetails
      ?.filter((payment) => payment.is_active)
      ?.reduce((acc, item) => acc + (parseFloat(item.unit_rate) || 0), 0);

  useEffect(() => {
    const totalAmountData = formData?.inputData?.orderItemDetails
      ?.filter((payment) => payment.is_active)
      ?.reduce((acc, item) => {
        const itemTotal = parseFloat(item.qty * item?.unit_rate) || 0;
        const gstPercentage = parseFloat(item?.gst_percentage) || 0;
        const gstAmount = (itemTotal * gstPercentage) / 100;
        return acc + itemTotal + gstAmount;
      }, 0);

    setFormData((prev) => ({
      ...prev,
      inputData: {
        ...prev.inputData,
        order_amount: totalAmountData,
      },
    }));
  }, [formData?.inputData?.orderItemDetails]);

  const totalAmountData =
    formData?.inputData?.orderItemDetails
      ?.filter((payment) => payment.is_active)
      ?.reduce((acc, item) => {
        const itemTotal = parseFloat(item.qty * item?.unit_rate) || 0; // Base amount
        const gstPercentage = parseFloat(item?.gst_percentage) || 0; // GST percentage (e.g., "10% GST" -> 10)
        const gstAmount = (itemTotal * gstPercentage) / 100; // Calculate GST amount
        return acc + itemTotal + gstAmount;
      }, 0) || 0;

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const validationErrors = TransactionalValidation(
        validationType,
        formData.inputData
      );

      if (Object.keys(validationErrors).length > 0) {
        setFormErrors(validationErrors);
        return;
      }

      let updatedFormData = { ...formData };
      const errors = { orderItemDetails: {}, orderPaymentDetails: {} };
      if (
        !updatedFormData?.inputData?.orderPaymentDetails?.some(
          (payment) => payment.is_active
        )
      ) {
        toast.error("Please add payment details");
        return;
      }

      const totalPercentage = updatedFormData?.inputData?.orderPaymentDetails
        ?.filter((payment) => payment.is_active) // Only consider active payments
        .reduce(
          (sum, payment) => sum + parseFloat(payment.percentage || "0"),
          0
        );

      // Validate orderItemDetails with only active items
      updatedFormData?.inputData?.orderItemDetails?.forEach((row, index) => {
        if (row.is_active) {
          // Only validate if is_active is true
          [
            "item_id",
            "qty",
            "customer_desc",
            "unit_rate",
            "gst_percentage",
          ].forEach((field) => {
            if (!row[field]?.toString().trim()) {
              errors.orderItemDetails = {
                ...errors.orderItemDetails,
                [index]: {
                  ...errors.orderItemDetails?.[index],
                  [field]: `${field
                    .replace(/_/g, " ")
                    ?.replace(/\b\w/g, (char) =>
                      char?.toUpperCase()
                    )} is required`,
                },
              };
            } else if (field === "qty") {
              const value = parseFloat(row[field]);
              if (value <= 0) {
                errors.orderItemDetails = {
                  ...errors.orderItemDetails,
                  [index]: {
                    ...errors.orderItemDetails?.[index],
                    [field]: "Invalid qty",
                  },
                };
              }

              const invoice_qty = row?.invoice_qty;
              // 4 > 5
              if (value < invoice_qty) {
                errors.orderItemDetails = {
                  ...errors.orderItemDetails,
                  [index]: {
                    ...errors.orderItemDetails?.[index],
                    [field]: "Order Qty Should Not less that Invoice Qty",
                  },
                };
              }
            }
          });
        }
      });
      updatedFormData?.inputData?.orderPaymentDetails?.forEach((row, index) => {
        if (row.is_active) {
          ["stage_id", "percentage", "date"].forEach((field) => {
            if (!row[field]?.toString().trim()) {
              errors.orderPaymentDetails[index] = {
                ...errors.orderPaymentDetails[index],
                [field]: `${field
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, (char) => char.toUpperCase())} is required`,
              };
            }
          });
        }
      });

      if (
        (Object.keys(errors.orderItemDetails).length > 0) |
        (Object.keys(errors.orderPaymentDetails).length > 0)
      ) {
        setFormErrors(errors);
        return;
      }

      if (totalPercentage !== 100) {
        toast.error(
          "The total of all payment percentages must add up to 100%."
        );
        return;
      }

      const additionalErrors = {};
      formData?.inputData?.order_documents?.forEach((row, index) => {
        if (row.is_active) {
          ["document", "file"].forEach((field) => {
            if (!row[field]?.toString().trim()) {
              additionalErrors.order_documents = {
                ...additionalErrors.order_documents,
                [index]: {
                  ...additionalErrors.order_documents?.[index],
                  [field]: `${field.replace(/_/g, " ")} is required`,
                },
              };
            }
          });
        }
      });
      if (Object.keys(additionalErrors).length > 0) {
        setFormErrors(additionalErrors);
        return;
      }

      if (updatedFormData?.inputData?.orderItemDetails) {
        updatedFormData.inputData.orderItemDetails =
          updatedFormData?.inputData?.orderItemDetails?.filter(
            (orderItem) => orderItem?.item_id && orderItem.item_id !== ""
            // orderItem.is_active
          );

        if (updatedFormData?.inputData?.orderItemDetails?.length === 0) {
          updatedFormData.inputData.orderItemDetails = [];
        } else {
          updatedFormData.inputData.orderItemDetails =
            updatedFormData?.inputData?.orderItemDetails?.map((orderItem) => {
              const {
                description,
                uom,
                buy_item_details,
                type,
                ...filteredOrderItem
              } = orderItem;

              let updatedBuyItemDetails = [];

              // If type == 1, include buy_item_details and update quantities
              if (type === 1 && buy_item_details) {
                updatedBuyItemDetails = buy_item_details?.map((buyItem) => {
                  const {
                    item_code,
                    description,
                    uom,
                    qty: buyQty,
                    ...filteredBuyItem
                  } = buyItem;

                  const updatedQty =
                    parseFloat(buyQty || "0") *
                    parseFloat(orderItem.qty || "0");

                  return {
                    ...filteredBuyItem,
                    item_code,
                    item_desc: description,
                    uom,
                    qty: updatedQty.toString(),
                  };
                });
              }

              return type === 1
                ? {
                    ...filteredOrderItem,
                    buy_item_details: updatedBuyItemDetails,
                  }
                : { ...filteredOrderItem };
            });
        }
      }

      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const project_id = JSON.parse(localStorage.getItem("projectID"));
      const isCreating = !id;
      const updatedInputData = {
        ...updatedFormData?.inputData,
        created_by: isCreating
          ? userDetails.id
          : updatedFormData.inputData.created_by,
        updated_by: userDetails.id,

        project_id: project_id,
        orderPaymentDetails:
          updatedFormData?.inputData?.orderPaymentDetails?.filter(
            (stage) =>
              // stage.is_active &&
              stage.percentage !== null &&
              stage.percentage !== "" &&
              stage.percentage != 0
          ),
      };

      const payload = {
        id: id,
        modelName: initialPayload?.modelName,
        relation: initialPayload?.relation,
        inputData: updatedInputData,
      };

      setLoadingData(true);
      const responseData = await saveRecords(payload, createEndpoint);

      if (responseData && responseData.code == 1) {
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData?.message || `Error while saving ${headerName}!`
        );
      }
      setLoadingData(false);
    } catch (error) {
      console.error("err", error);
    } finally {
      setLoadingData(false);
    }
  };

  const selectedItems = formData?.inputData?.orderItemDetails?.map(
    (row) => row.item_id
  );

  const selectedPaymentTerms = formData?.inputData?.orderPaymentDetails
    ?.filter((row) => row.is_active === true)
    .map((row) => row.stage_id);

  const handleAddItem = async (data) => {
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      orderItemDetails: [],
    }));

    const match = itemSelectOptions[0]?.options[0]?.data.find(
      (item) => item.item_code.toLowerCase() === data.toLowerCase()
    );

    if (!match) {
      toast.error("Item does not exist");
      return;
    }

    const isDuplicate = formData?.inputData?.orderItemDetails.some(
      (item) => item.item_id == match?.id && item.is_active === true
    );

    if (isDuplicate) {
      toast.error(
        "This item has already been added. Skipping duplicate entry."
      );
      return;
    }

    let emptyRowIndex = formData?.inputData?.orderItemDetails.findIndex(
      (item) => !item.item_id
    );

    if (emptyRowIndex != -1) {
      setItemCodeSelect((prev) => {
        const updatedArray = [...prev];
        updatedArray[emptyRowIndex] = {
          label: match.item_code,
          value: match.id,
        };
        return updatedArray;
      });

      await getItemMasterByIdData(match.id, emptyRowIndex);
      setSelectedFilteredItems((prev) => [...prev, match]);

      toast.success(`The item "${match.item_code}" added successfully`);

      setTimeout(() => {
        document
          .getElementById("table-container")
          ?.scrollTo({ top: 9999, behavior: "smooth" });
      }, 100);
    } else {
      let index = formData?.inputData?.orderItemDetails?.length || 0;

      setItemCodeSelect((prev) => {
        const updatedArray = [...prev];
        updatedArray[index] = { label: match.item_code, value: match.id };
        return updatedArray;
      });
      setSelectedFilteredItems((prev) => {
        const updatedArray = [...prev];
        updatedArray[index] = { label: match.item_code, value: match.id };
        return updatedArray;
      });
      await getItemMasterByIdData(match.id, index);
      toast.success(`The item "${match.item_code}" added successfully`);
      // setSelectedFilteredItems((prev) => [...prev, match]);

      setTimeout(() => {
        document
          .getElementById("table-container")
          ?.scrollTo({ top: 9999, behavior: "smooth" });
      }, 100);
    }
    setInputValue("");
    setFilteredOptions(
      itemSelectOptions[0]?.options.filter(
        (option) =>
          !selectedFilteredItems.some(
            (selected) =>
              (selected?.item_code && selected?.item_code == option?.label) ||
              (selected?.label && selected?.label == option?.label)
          )
      )
    );
  };

  const handleInputKeyDown = (e) => {
    setIsDropdownVisible(false);
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddItem(inputValue);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    const filteredData = itemSelectOptions[0].options
      .filter((option) =>
        option?.label?.toLowerCase().includes(value?.trim().toLowerCase())
      )
      .filter(
        (option) =>
          !selectedFilteredItems.some(
            (selected) =>
              (selected?.item_code && selected?.item_code == option?.label) ||
              (selected?.label && selected?.label == option?.label)
          )
      );

    setFilteredOptions(filteredData);
    setIsDropdownVisible(true);

    if (value === "") {
      setFilteredOptions(
        itemSelectOptions[0]?.options.filter(
          (option) =>
            !selectedFilteredItems.some(
              (selected) =>
                (selected?.item_code && selected?.item_code == option?.label) ||
                (selected?.label && selected?.label == option?.label)
            )
        )
      );
      setIsDropdownVisible(true);
    }
  };

  const handleItemSelect = async (item) => {
    if (!item || !item.label) {
      console.error("Invalid item selected:", item);
      return;
    }

    setInputValue(item.label);
    const data = item.label;
    setIsDropdownVisible(false);

    handleAddItem(data);
  };
  const closePopup = () => {
    setPopupData((prev) => ({ ...prev, isOpen: false }));
  };

  useEffect(() => {
    const filteredOptionsWithoutSelectedItems = filteredOptions?.filter(
      (item) =>
        !(selectedFilteredItems ?? []).some(
          (selected) =>
            selected?.item_code?.toString().trim().toLowerCase() ==
              item?.label?.toString().trim().toLowerCase() ||
            selected?.label?.toString().trim().toLowerCase() ==
              item?.label?.toString().trim().toLowerCase()
        )
    );
    setFilteredOptionsWithoutSelected(filteredOptionsWithoutSelectedItems);
  }, [filteredOptions, selectedFilteredItems]);

  const handleImportItemDetail = async (e) => {
    try {
      const file = e.target.files[0];
      if (!file) return;
      e.target.value = null;

      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (fileExtension !== "xlsx" && fileExtension !== "xls") {
        toast.error("Please select a valid Excel file.");
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        return;
      }

      const reader = new FileReader();
      reader.readAsBinaryString(file);

      reader.onload = async (event) => {
        try {
          const binaryStr = event.target.result;
          const workbook = XLSX.read(binaryStr, { type: "binary" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const data = XLSX.utils.sheet_to_json(sheet);

          if (!data || data?.length === 0) {
            setPopupData({
              isOpen: true,
              message: `The uploaded file is empty or not formatted correctly.`,
              isError: true,
            });
            if (fileInputRef.current) {
              fileInputRef.current.value = "";
            }
            return;
          }

          // No need to filter unique items; allow duplicates
          const matchedData = data?.flatMap((excelItem) =>
            filteredOptions.filter(
              (item) =>
                item.label?.toString().trim().toLowerCase() ===
                excelItem.item_code?.toString().trim().toLowerCase()
            )
          );

          const uploadedItemCodes = data?.map(
            (dataItem) => dataItem?.item_code
          );

          const matchedItemCodes = matchedData?.map((item) =>
            item?.label.trim()
          );

          const unmatchedItemCodes = uploadedItemCodes?.filter(
            (code) =>
              !matchedItemCodes.map(String).includes(String(code.trim()))
          );

          if (!matchedData || matchedData?.length === 0) {
            setPopupData({
              isOpen: true,
              message: "No matching data found in the uploaded file.",
              isError: true,
            });
            if (fileInputRef.current) {
              fileInputRef.current.value = "";
            }
            return;
          }

          if (matchedData) {
            setItemCodeSelect((prev) => {
              const updatedArray = [...prev];
              matchedData?.forEach((match) => {
                updatedArray.push({
                  label: match?.label.trim(),
                  value: match?.value,
                });
              });
              return updatedArray;
            });
          }
          const itemIds = matchedData?.map((row) => row?.value);

          let payload = {
            modelName: "item_masters",
            whereCondition: {
              id: {
                in: itemIds,
              },
            },
            relations: [
              {
                module: "bom_masters",
                moduleAs: "bomMakeItem",
                subModule: "item_masters",
                subModuleAs: "buyItem",
                subSubModule: "uom_masters",
                subSubModuleAs: "uom",
              },
              {
                module: "uom_masters",
                moduleAs: "uom",
              },
              {
                module: "category_masters",
                moduleAs: "category",
              },
              {
                module: "user_masters",
                moduleAs: "createdBy",
              },
              {
                module: "user_masters",
                moduleAs: "updatedBy",
              },
            ],
          };

          setLoadingData(true);
          const responseData = await getRecords(payload, "/getItemById");

          if (responseData?.data && responseData?.data?.length > 0) {
            let updatedRecords = [];

            data.forEach((excelItem) => {
              const matchingItem = responseData.data.find(
                (item) =>
                  item.item_code?.toString().trim().toLowerCase() ===
                  excelItem.item_code?.toString().trim().toLowerCase()
              );

              if (matchingItem) {
                updatedRecords.push({
                  item_id: matchingItem.id,
                  item_code: excelItem.item_code || matchingItem.item_code,
                  description: excelItem.item_desc || matchingItem.description,
                  customer_desc: excelItem.item_customer_desc || "",
                  uom: excelItem.uom || matchingItem.uom?.uom_name,
                  type: matchingItem.type,
                  unit_rate: excelItem.unit_rate,
                  qty: excelItem.qty,
                  gst_percentage: excelItem.gst_percentage,
                  amount: parseFloat(
                    (
                      excelItem.qty *
                      excelItem.unit_rate *
                      (1 + excelItem.gst_percentage / 100)
                    ).toFixed(3)
                  ),
                  is_active: matchingItem.is_active,
                  ...(matchingItem.type == 1 && {
                    buy_item_details: matchingItem.bomMakeItem
                      ? matchingItem.bomMakeItem.map((bomItem) => ({
                          item_id: bomItem.buyItem.id,
                          item_code: bomItem.buyItem.item_code,
                          description: bomItem.buyItem.description,
                          qty: bomItem.qty_per_item,
                          uom: bomItem.buyItem.uom?.uom_name,
                        }))
                      : [],
                  }),
                });
              }
            });

            setFormErrors((prev) => ({
              ...prev,
              orderItemDetails: {},
            }));

            //      setFormErrors(prevErrors => {
            //   const newErrors = {...prevErrors};

            //   if (newErrors.orderItemDetails) {
            //     // Clear errors for all imported items
            //     updatedRecords.forEach((item, index) => {
            //       if (newErrors.orderItemDetails[index]) {
            //         // Clear specific field errors if the imported data provides valid values
            //         if (item.qty) delete newErrors.orderItemDetails[index].qty;
            //         if (item.unit_rate) delete newErrors.orderItemDetails[index].unit_rate;
            //         if (item.gst_percentage) delete newErrors.orderItemDetails[index].gst_percentage;
            //         if (item.customer_desc) delete newErrors.orderItemDetails[index].customer_desc;

            //         // Remove the index entirely if no errors left
            //         if (Object.keys(newErrors.orderItemDetails[index]).length === 0) {
            //           delete newErrors.orderItemDetails[index];
            //         }
            //       }
            //     });

            //     // Remove orderItemDetails if empty
            //     if (Object.keys(newErrors.orderItemDetails).length === 0) {
            //       delete newErrors.orderItemDetails;
            //     }
            //   }

            //   return newErrors;
            // });

            setFormData((prev) => ({
              ...prev,
              inputData: {
                ...prev.inputData,
                orderItemDetails: updatedRecords,
              },
            }));

            setPopupData({
              isOpen: true,
              message: "File imported successfully!",
              isError: false,
              unmatchedItems: unmatchedItemCodes,
              matchedItems: matchedData,
            });
          }
        } catch (error) {
          setLoadingData(false);
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }

          console.error("Processing error:", error);
          setPopupData({
            isOpen: true,
            message: "Error processing the file. Please check the format.",
            isError: true,
          });
        } finally {
          setLoadingData(false);
        }
      };

      reader.onerror = () => {
        console.error("File reading error");
        setPopupData({
          isOpen: true,
          message: "Error importing file. Please try again.",
          isError: true,
        });
      };
    } catch (error) {
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      console.error("Upload error:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };
  let visibleRowCount = 0;

  return (
    <CustomForm
      title={"CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <ModernPopup
        isOpen={popupData.isOpen}
        onClose={closePopup}
        message={popupData.message}
        isError={popupData.isError}
        unmatchedItems={popupData?.unmatchedItems}
        matchedItems={popupData?.matchedItems}
      />

      {!id && (
        <Row>
          <Col className="d-flex justify-content-end text-center">
            <Button
              color="success"
              className="waves-effect waves-light me-1"
              onClick={() => document.getElementById("fileInput").click()}
            >
              Import Items
            </Button>
            <input
              ref={fileInputRef}
              type="file"
              id="fileInput"
              style={{ display: "none" }}
              accept=".xlsx, .xls"
              onChange={(e) => handleImportItemDetail(e)}
            />
          </Col>
        </Row>
      )}

      <Row className="mt-2">
        {/* First Row */}
        <Col md="4" className="mt-3">
          <TextInput
            label="So No"
            name="order_no"
            value={formData?.inputData?.order_no}
            onChange={onInputChange}
            placeholder="So No"
            parentClassName=""
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.order_no && "So No is required"}
          />
        </Col>
        <Col md="4" className="mt-3">
          <TextInput
            label="Order reference no"
            name="order_ref_no"
            value={formData?.inputData?.order_ref_no}
            onChange={onInputChange}
            placeholder="Order reference"
            parentClassName=""
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.order_ref_no}
          />
        </Col>
        <Col md="4" className="mt-3">
          <SelectInput
            label="Customer"
            value={customerSelect}
            options={customerSelectOptions}
            onSelect={(selected) => handleCustomerSelect(selected)}
            placeholder="Select customer"
            labelClassName="form-label"
            isClearable={true}
            asterisk={true}
            customError={formErrors?.customer_id}
          />
        </Col>

        <Col md="4" className="mt-3">
          <DatePicker
            label="Order date"
            name="order_date"
            value={formatDate(formData?.inputData?.order_date)}
            onChange={onInputChange}
            parentClassName=""
            inputClassName="form-control"
            labelClassName="form-label"
            placeholder="DD/MM/YYYY"
            inputStyle={{ textTransform: "uppercase" }}
            asterisk={true}
            customError={formErrors?.order_date}
          />
        </Col>

        <Col md="4" className="mt-3">
          <TextInput
            label="Order amount"
            name="order_amount"
            value={formData?.inputData?.order_amount}
            placeholder="Order amount"
            onChange={onInputChange}
            parentClassName=""
            inputClassName="form-control"
            labelClassName="form-label"
            disabled={true}
          />
        </Col>
        <Col md="4" className="mt-3">
          <TextInput
            label="GST No"
            name="gst_no"
            value={formData?.inputData?.gst_no}
            placeholder="No data found"
            parentClassName=""
            inputClassName="form-control"
            labelClassName="form-label"
            disabled={true}
          />
        </Col>
        <Col md="4" className="mt-3">
          <TextInput
            label="Pan No"
            name="pan_no"
            value={formData?.inputData?.pan_no}
            placeholder="No data found"
            parentClassName=""
            inputClassName="form-control"
            labelClassName="form-label"
            disabled={true}
          />
        </Col>
        <Col md="4" className="mt-3">
          <TextAreaInput
            label="Address"
            name="address"
            value={formData?.inputData?.address}
            onChange={onInputChange}
            parentClassName=""
            inputClassName="form-control"
            labelClassName="form-label"
            placeholder="Address"
          />
        </Col>
        <Col md="4" className="mt-3">
          <TextAreaInput
            label="Shipping address"
            name="shipping_address"
            value={formData?.inputData?.shipping_address}
            onChange={onInputChange}
            parentClassName=""
            inputClassName="form-control"
            labelClassName="form-label"
            placeholder="Shipping address"
          />
        </Col>

        {/* Fifth Row */}
        <Col md="4" className="mt-3">
          <TextAreaInput
            label="Billing address"
            name="billing_address"
            value={formData?.inputData?.billing_address}
            onChange={onInputChange}
            parentClassName=""
            inputClassName="form-control"
            labelClassName="form-label"
            placeholder="Billing address"
          />
        </Col>
      </Row>

      <Row className="mt-4 " style={{ position: "relative" }}>
        <Col className="responsive-flex">
          <div>
            <h6 className="h-6-heading">Item Details</h6>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <div className="app-search d-flex d-lg-inline mt-0 w-25">
                <div className="position-relative">
                  <input
                    ref={inputRef}
                    id="itemCode"
                    type="text"
                    value={inputValue}
                    onChange={handleInputChange}
                    onKeyDown={handleInputKeyDown}
                    placeholder="Add item code..."
                    className="form-control ps-5"
                    autoComplete="off"
                    onFocus={() => {
                      setIsDropdownVisible(true);

                      if (inputValue) {
                        setFilteredOptions(
                          itemSelectOptions[0].options
                            .filter((option) =>
                              option?.label
                                .toLowerCase()
                                .includes(inputValue?.trim().toLowerCase())
                            )
                            .filter(
                              (option) =>
                                !selectedFilteredItems.some(
                                  (selected) =>
                                    (selected?.item_code &&
                                      selected?.item_code == option?.label) ||
                                    (selected?.label &&
                                      selected?.label == option?.label)
                                )
                            )
                        );
                      }
                    }}
                    style={{
                      width: "13rem",
                      padding: "8px 15px",
                      borderRadius: "8px",
                      borderColor: "#D2D2D2",
                      outline: "none",
                      transition: "all 0.3s ease",
                      boxShadow: "none",
                      marginRight: "0.5rem",
                    }}
                  />
                  <span className="ri-search-line"></span>
                </div>
              </div>

              {isDropdownVisible && (
                <div
                  ref={dropdownRef}
                  style={{
                    width: "13rem",
                    maxHeight: "150px",
                    overflowY: "auto",
                    border: "1px solid #D2D2D2",
                    borderRadius: "8px",
                    marginTop: "5px",
                    position: "absolute",
                    backgroundColor: "#fff",
                    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                    zIndex: "1000",
                  }}
                >
                  {filteredOptionsWithoutSelected &&
                  filteredOptionsWithoutSelected.length > 0 ? (
                    filteredOptionsWithoutSelected?.map((item, index) => (
                      <div
                        key={index}
                        onClick={() => {
                          handleItemSelect(item);
                        }}
                        style={{
                          padding: "8px 15px",
                          cursor: "pointer",
                          borderBottom: "1px solid #f0f0f0",
                        }}
                        onMouseEnter={(e) =>
                          (e.target.style.backgroundColor = "#f0f0f0")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.backgroundColor = "transparent")
                        }
                      >
                        {item.label}
                      </div>
                    ))
                  ) : (
                    <div
                      style={{
                        padding: "8px 15px",
                        cursor: "pointer",
                        borderBottom: "1px solid #f0f0f0",
                        textAlign: "center",
                        color: "gray",
                      }}
                    >
                      No Data..
                    </div>
                  )}
                </div>
              )}
            </div>
            <Button
              color="primary"
              className="waves-effect waves-light me-1 "
              onClick={handleAddItemDetail}
              style={{ background: "#006eb9" }}
            >
              Add
            </Button>
          </div>
        </Col>

        <div
          className="table"
          // className="table table-responsive"
          style={{
            overflowX: "auto",
            overflowY: "auto",
            maxHeight: "500px",
            width: "100%",
            scrollBehavior: "smooth",
            scrollbarWidth: "thin",
            msOverflowStyle: "none",
            zIndex: 0,
          }}
        >
          <table className="table table-hover">
            <thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#8AC1E8",
                zIndex: 40000,
              }}
            >
              <tr
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1050,
                  backgroundColor: "#8AC1E8",
                  borderBottom: "1px solid black",
                }}
              >
                <th style={{ whiteSpace: "nowrap" }}>
                  Item Code <Asterisks asterisk={true} />
                </th>
                <th style={{ whiteSpace: "nowrap" }}>Item Desc</th>
                <th style={{ whiteSpace: "nowrap" }}>
                  Customer Desc <Asterisks asterisk={true} />
                </th>
                <th style={{ whiteSpace: "nowrap" }}>UOM</th>
                <th style={{ whiteSpace: "nowrap" }}>
                  Order QTY <Asterisks asterisk={true} />
                </th>
                {id && <th style={{ whiteSpace: "nowrap" }}>Invoice QTY</th>}
                <th style={{ whiteSpace: "nowrap" }}>
                  Unit Rate <Asterisks asterisk={true} />
                </th>
                <th style={{ whiteSpace: "nowrap" }}>
                  GST % <Asterisks asterisk={true} />
                </th>
                <th style={{ whiteSpace: "wrap" }}>Total Amount</th>
                <th style={{ whiteSpace: "nowrap" }} colSpan="4">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {formData?.inputData?.orderItemDetails &&
              formData?.inputData?.orderItemDetails?.length > 0 ? (
                formData?.inputData?.orderItemDetails?.map((row, index) => {
                  const isDisabled =
                    row?.is_order_item_invoice_completed === true;

                  return (
                    row?.is_active == true && (
                      <React.Fragment key={index}>
                        <tr
                          style={{
                            borderBottom: "1px solid #cccccc",
                            // verticalAlign: "middle",
                            // height: "5px",
                          }}
                        >
                          {/* <td>{index + 1}</td> */}

                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "180px",
                            }}
                          >
                            <SelectInputPercentage
                              value={itemCodeSelect[index]}
                              options={itemSelectOptions} // Remove filtering logic
                              onSelect={(selected) =>
                                handleDropdownChange(index, selected)
                              }
                              placeholder="Select item"
                              isClearable={false}
                              labelStyle={{ display: "none" }}
                              selectStyle={{
                                position: "absolute",
                                zIndex: 1050,
                              }}
                              customError={
                                formErrors?.orderItemDetails?.[index]?.item_id
                              }
                              disabled={isDisabled}
                            />
                          </td>

                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "180px",
                            }}
                          >
                            <div
                              style={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                              }}
                              title={row?.description || "N/A"}
                            >
                              {row?.description || "N/A"}
                            </div>
                          </td>

                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "180px",
                            }}
                          >
                            <TextAreaInput
                              onChange={(e) =>
                                handleDescriptionChange(
                                  e.target.value,
                                  index,
                                  "customer_desc"
                                )
                              }
                              value={row?.customer_desc || ""}
                              placeholder="customer desc"
                              inputClassName="form-control"
                              labelClassName="form-label"
                              labelStyle={{ display: "none" }}
                              customError={
                                formErrors?.orderItemDetails?.[index]
                                  ?.customer_desc
                              }
                              disabled={isDisabled}
                              rows={1}
                            />
                          </td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "100px",
                            }}
                          >
                            {row?.uom || "N/A"}
                          </td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "110px",
                            }}
                          >
                            <NumberInput
                              name="order_qty"
                              onChange={(e) =>
                                handleQTYChange(
                                  e.target.value,
                                  index,
                                  "qty",
                                  row
                                )
                              }
                              value={row?.qty}
                              placeholder="order qty"
                              inputClassName="form-control"
                              labelClassName="form-label"
                              labelStyle={{ display: "none" }}
                              customError={
                                formErrors?.orderItemDetails?.[index]?.qty
                              }
                              disabled={isDisabled}
                            />
                          </td>
                          {id && (
                            <td>
                              {isNaN(parseFloat(row?.invoice_qty))
                                ? "0"
                                : parseFloat(row?.invoice_qty)}
                            </td>
                          )}
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "110px",
                            }}
                          >
                            <NumberInput
                              name="unit_rate"
                              onChange={(e) =>
                                handleUnitRateChange(
                                  e.target.value,
                                  index,
                                  "unit_rate"
                                )
                              }
                              value={row?.unit_rate || ""}
                              placeholder="unit rate"
                              inputClassName="form-control"
                              labelClassName="form-label"
                              labelStyle={{ display: "none" }}
                              customError={
                                formErrors?.orderItemDetails?.[index]?.unit_rate
                              }
                              disabled={isDisabled}
                            />
                          </td>

                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "136px",
                            }}
                          >
                            <NumberInput
                              onChange={(e) =>
                                handleGSTChange(
                                  e.target.value,
                                  index,
                                  "gst_percentage"
                                )
                              }
                              onBlur={() => {
                                const formattedValue = parseFloat(
                                  row?.gst_percentage || 0
                                );
                                handleGSTChange(
                                  formattedValue,
                                  index,
                                  "gst_percentage"
                                );
                              }}
                              value={row?.gst_percentage || ""}
                              placeholder="gst percentage"
                              inputClassName="form-control"
                              labelClassName="form-label"
                              labelStyle={{ display: "none" }}
                              customError={
                                formErrors?.orderItemDetails?.[index]
                                  ?.gst_percentage
                              }
                              disabled={isDisabled}
                            />
                          </td>

                          <td>{formatNumber(row?.amount)}</td>
                          <td colSpan="4">
                            {!row?.is_order_item_invoice_completed && (
                              <div className="d-flex gap-3">
                                <div
                                  onClick={() => {
                                    if (row.id) {
                                      if (row.invoice_qty === 0) {
                                        handleRemoveItemDetail(
                                          row.item_id,
                                          index
                                        );
                                      }
                                    } else {
                                      handleRemoveItemDetail(
                                        row.item_id,
                                        index
                                      );
                                    }
                                  }}
                                >
                                  <span
                                    style={{
                                      cursor:
                                        !row.id || row.invoice_qty === 0
                                          ? "pointer"
                                          : "not-allowed",

                                      opacity:
                                        row.id && row.invoice_qty !== 0
                                          ? 0.5
                                          : 1,
                                    }}
                                    className={`text-danger ${
                                      row.id && row.invoice_qty !== 0
                                        ? "disabled"
                                        : ""
                                    }`}
                                  >
                                    <i className="mdi mdi-trash-can font-size-20"></i>
                                  </span>
                                </div>
                                {row?.type === 1 && (
                                  <div
                                    color="info"
                                    onClick={() =>
                                      toggleChildBuyItemDetail(index)
                                    }
                                  >
                                    {expandedRows[index] ? (
                                      <span className="text-primary">
                                        <i className="mdi mdi-minus font-size-22"></i>
                                      </span>
                                    ) : (
                                      <span className="text-primary">
                                        <i className="mdi mdi-plus font-size-22"></i>
                                      </span>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                          </td>
                        </tr>

                        {expandedRows[index] && (
                          <>
                            {/* Sub Item Header */}
                            <tr
                              style={{
                                backgroundColor: "#d1ecf1",
                                fontWeight: "bold",
                              }}
                            >
                              <td></td>
                              <td>Buy Item Code</td>
                              <td>Buy Item Description</td>
                              <td>UOM</td>
                              <td>BOM QTY</td>
                              <td colSpan="10"></td>
                            </tr>
                            {row?.buy_item_details &&
                              row?.buy_item_details?.map(
                                (child, childIndex) => (
                                  <>
                                    <tr
                                      key={`${index}-${childIndex}`}
                                      style={{
                                        backgroundColor: "",
                                        borderBottom: "1px solid #cccccc",
                                      }}
                                    >
                                      <td></td>
                                      <td
                                        style={{
                                          paddingLeft: "10px",
                                          paddingRight: "2px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "-webkit-box",
                                            WebkitBoxOrient: "vertical",
                                            WebkitLineClamp: 2,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "normal",
                                          }}
                                          title={child?.item_code || "N/A"}
                                        >
                                          {child?.item_code || "N/A"}
                                        </div>
                                      </td>
                                      <td
                                        style={{
                                          paddingLeft: "10px",
                                          paddingRight: "2px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "-webkit-box",
                                            WebkitBoxOrient: "vertical",
                                            WebkitLineClamp: 2,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "normal",
                                          }}
                                          title={
                                            child?.description ||
                                            child?.item_desc ||
                                            "N/A"
                                          }
                                        >
                                          {child?.description ||
                                            child?.item_desc ||
                                            "N/A"}
                                        </div>
                                      </td>
                                      <td
                                        style={{
                                          paddingLeft: "10px",
                                          paddingRight: "2px",
                                        }}
                                      >
                                        {child?.uom}
                                      </td>
                                      <td
                                        style={{
                                          paddingLeft: "10px",
                                          paddingRight: "2px",
                                        }}
                                      >
                                        {child?.qty && row?.qty
                                          ? parseFloat(row?.qty * child?.qty)
                                          : "0"}
                                      </td>
                                      <td colSpan="10"></td>
                                    </tr>
                                  </>
                                )
                              )}
                          </>
                        )}
                      </React.Fragment>
                    )
                  );
                })
              ) : (
                <tr>
                  <td colSpan="12" style={{ textAlign: "center" }}>
                    No data available.
                  </td>
                </tr>
              )}

              {totalQty >= 1 && (
                <tr
                  style={{
                    borderTop: "2px solid #cccccc",
                    backgroundColor: "#d9d9d9",
                    fontWeight: "bold",
                    position: "sticky",
                    bottom: 0,
                    zIndex: 40000,
                  }}
                >
                  <td>Total</td>
                  <td></td>
                  <td colSpan="2"></td>
                  <td>{formatNumber(totalQty)}</td>
                  {id && <td></td>}
                  <td>{formatNumber(totalUnitRate)}</td>
                  <td></td>
                  <td>{formatNumber(totalAmountData)}</td>
                  <td colSpan="4"></td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Row>

      <Row className="mt-4">
        <Col
          style={{
            marginLeft: "",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <h6
            className="h-6-heading"
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#333",
              backgroundColor: "#f8f9fa",
              padding: "5px 20px",
              paddingTop: "10px",
              borderRadius: "8px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              display: "inline-block",
              margin: "0",
            }}
          >
            Payment Details
          </h6>
          <Button
            color="primary"
            className="waves-effect waves-light me-1 "
            onClick={handleAddPaymentDetails}
            style={{ background: "#006eb9" }}
          >
            Add
          </Button>
        </Col>

        <div
          className="table mt-2"
          style={{
            maxHeight: "450px",
            overflowY: "auto",
            width: "100%",
            scrollBehavior: "smooth",
          }}
        >
          <table className="table table-hover">
            <thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#8AC1E8",
                zIndex: 1,
              }}
            >
              <tr
                style={{
                  borderBottom: "1px solid black",
                }}
              >
                <th style={{ whiteSpace: "nowrap" }}>Sr. No</th>
                <th style={{ whiteSpace: "nowrap" }}>
                  Stage <Asterisks asterisk={true} />
                </th>
                <th style={{ whiteSpace: "nowrap" }}>
                  Percentage <Asterisks asterisk={true} />
                </th>
                <th style={{ whiteSpace: "nowrap" }}>
                  Date <Asterisks asterisk={true} />
                </th>
                <th style={{ whiteSpace: "nowrap" }}>Actions</th>
              </tr>
            </thead>

            <tbody>
              {formData &&
                formData?.inputData &&
                formData?.inputData?.orderPaymentDetails &&
                formData?.inputData?.orderPaymentDetails?.map((item, index) => {
                  const matchedValue = stageSelectOption?.[0]?.options?.find(
                    (option) => option?.value === item?.stage_id
                  );
                  if (!item?.is_active) return null;

                  visibleRowCount++;

                  return (
                    // item?.is_active == true &&
                    <React.Fragment key={index + 1}>
                      <tr
                        style={{
                          borderBottom: "1px solid #cccccc",
                          // verticalAlign: "middle",
                        }}
                      >
                        <td>{visibleRowCount}</td>
                        <td
                          style={{
                            minWidth: "200px",
                          }}
                        >
                          <SelectInput
                            label=""
                            value={matchedValue || []}
                            options={stageSelectOption?.map((optionGroup) => {
                              return {
                                ...optionGroup,
                                options: optionGroup.options.filter(
                                  (option) =>
                                    !selectedPaymentTerms.includes(option.value)
                                ),
                              };
                            })}
                            onSelect={(selected) =>
                              handleStageSelect(selected, index)
                            }
                            placeholder="Select stage"
                            labelStyle={{ display: "none" }}
                            isClearable={false}
                            customError={
                              formErrors?.orderPaymentDetails?.[index]?.stage_id
                            }
                          />
                        </td>
                        <td
                          style={{
                            width: "300px",
                            minWidth: "300px",
                            maxWidth: "300px",
                          }}
                        >
                          <NumberInput
                            name="percentage"
                            value={item?.percentage || ""}
                            onChange={(e) => handlePercentageChange(e, index)}
                            placeholder="percentage"
                            inputClassName="form-control"
                            labelClassName="form-label"
                            labelStyle={{ display: "none" }}
                            customError={
                              formErrors?.orderPaymentDetails?.[index]
                                ?.percentage
                            }
                          />
                        </td>
                        <td
                          style={{
                            minWidth: "120px",
                          }}
                        >
                          <DatePicker
                            name="date"
                            value={item?.date ? item.date.split("T")[0] : ""}
                            onChange={(e) => handleDateChange(e, index)}
                            placeholder="date"
                            inputClassName="form-control"
                            labelClassName="form-label"
                            labelStyle={{ display: "none" }}
                            customError={
                              formErrors?.orderPaymentDetails?.[index]?.date
                            }
                          />
                        </td>
                        <td>
                          <div
                            onClick={() => handleRemovePaymentDetails(index)}
                          >
                            <Link className="text-danger">
                              <i className="mdi mdi-trash-can font-size-18"></i>
                            </Link>
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })}
            </tbody>
          </table>
        </div>
      </Row>

      <Row className="mt-4">
        <Col
          style={{
            marginLeft: "",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingBlock: "5px",
            gap: "1rem",
          }}
        >
          <div>
            <h6 className="h-6-heading m-0">Document Details</h6>
          </div>
          <Button
            color="primary"
            className="waves-effect waves-light me-1"
            onClick={handleAddUserDocuments}
            style={{ background: "#006eb9" }}
          >
            Add
          </Button>
        </Col>
        <div
          className="table mt-2"
          style={{
            maxHeight: "450px",
            overflowY: "auto",
            width: "100%",
            scrollbarWidth: "thin",
            scrollBehavior: "smooth",
          }}
        >
          <table className="table table-hover">
            <thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#8AC1E8",
                zIndex: 1,
              }}
            >
              <tr style={{ borderBottom: "1px solid black" }}>
                <th style={{ whiteSpace: "nowrap" }}>Sr. No</th>
                <th style={{ whiteSpace: "nowrap" }}>
                  Document Name <Asterisks asterisk={true} />
                </th>
                <th style={{ whiteSpace: "nowrap" }}>
                  Document <Asterisks asterisk={true} />
                </th>
                <th style={{ whiteSpace: "nowrap" }}>Preview</th>
                <th style={{ whiteSpace: "nowrap" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {formData?.inputData &&
                formData?.inputData?.order_documents &&
                formData?.inputData?.order_documents.map(
                  (item, index) =>
                    item.is_active == true && (
                      <React.Fragment key={index + 1}>
                        <tr
                          style={{
                            borderBottom: "1px solid #cccccc",
                            verticalAlign: "middle",
                          }}
                        >
                          <td>{index + 1}</td>
                          <td>
                            <TextInput
                              name="document"
                              value={item.document}
                              onChange={(e) =>
                                handleUserDocumentsOnChange(e, index)
                              }
                              placeholder="Document"
                              inputClassName="form-control"
                              labelClassName="form-label"
                              labelStyle={{ display: "none" }}
                              asterisk={true}
                              customError={
                                formErrors?.order_documents?.[index]
                                  ?.document || ""
                              }
                            />
                          </td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "110px",
                            }}
                          >
                            <div style={{ position: "relative" }}>
                              <input
                                name="file"
                                type="file"
                                accept="image/*"
                                onChange={(e) =>
                                  handleUserDocumentFileChange(e, index)
                                }
                                className="form-control"
                                style={{
                                  border:
                                    formErrors?.order_documents?.[index]
                                      ?.file && "1px solid red",
                                  borderColor:
                                    formErrors?.order_documents?.[index]
                                      ?.file && "#d15757",
                                  boxShadow:
                                    formErrors?.order_documents?.[index]
                                      ?.file &&
                                    "0px 0px 3px rgba(255, 0, 0, 0.5)",
                                }}
                              />
                              {formErrors?.order_documents?.[index]?.file && (
                                <i
                                  className="fas fa-exclamation-circle"
                                  style={{
                                    position: "absolute",
                                    top: "50%",
                                    right: "10px",
                                    transform: "translateY(-50%)",
                                    color: "#d15757",
                                  }}
                                ></i>
                              )}
                            </div>
                            {formErrors?.order_documents?.[index]?.file && (
                              <CustomError
                                error={
                                  formErrors?.order_documents?.[index]?.file ||
                                  ""
                                }
                              />
                            )}
                          </td>
                          <td>
                            {!id && item?.preview ? (
                              <img
                                src={item?.preview}
                                alt="Preview"
                                style={{ width: "100px", height: "100px" }}
                                onError={(e) =>
                                  (e.target.src = "/placeholder.png")
                                }
                              />
                            ) : item?.file ? (
                              <img
                                src={imageURL + item?.file}
                                onClick={() =>
                                  handleImageClick(imageURL + item?.file)
                                }
                                alt="Preview"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  cursor: "pointer",
                                }}
                                onError={(e) =>
                                  (e.target.src = "/placeholder.png")
                                }
                              />
                            ) : (
                              <span>Preview</span>
                            )}
                          </td>

                          <td>
                            <div
                              onClick={() => handleRemoveUserDocuments(index)}
                            >
                              <Link className="text-danger">
                                <i className="mdi mdi-trash-can font-size-20"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    )
                )}
            </tbody>
          </table>
        </div>
      </Row>

      <Row className="mt-3">
        <Col md="4">
          <TextAreaInput
            label="Remark"
            name="remark"
            value={formData?.inputData?.remark}
            onChange={onInputChange}
            parentClassName=""
            inputClassName="form-control"
            labelClassName="form-label"
            placeholder="Remark"
          />
        </Col>
      </Row>

      <Row className="mt-4">
        <Col lg="12">
          <CheckboxInput
            label="Is Active"
            name="is_active"
            value={formData.inputData.is_active}
            checked={formData.inputData.is_active}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
            disabled={false}
            required={false}
          />
        </Col>
      </Row>
    </CustomForm>
  );
};

export default OrderCreate;
